export const isPartialData = data => !!(data?.returnUrl && !data?.id && !data?.sessionData);
